import script from "./PermissionHelp.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionHelp.vue?vue&type=script&setup=true&lang=js"

import "./PermissionHelp.vue?vue&type=style&index=0&id=a47cc32a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a47cc32a"]])

export default __exports__